




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SMSRechargePO from "@/store/entities/messageinfo/smsrechargelistpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import QRCode from "qrcodejs2";
@Component({
  components: { TreeSelect },
})
export default class PaySMSOrder extends AbpBase {
  smsrechargepo: SMSRechargePO = new SMSRechargePO();
  treedata: [] = [];
  loading: boolean = false;
  orgniationNam: string = "";
  smspackageName: string = "";
  paytypeName: string = "";
  smspackage: any[] = []; //短信包套餐
  timer: number;
  troadeNo: string = ""; //交换订单号
  num: number = 0;
  async created() {
    //await this.getOrganizations();
  }
  async mounted() {
    await this.getSMSPackage();
    let params = this.$route.params;
    (this.smsrechargepo as any) = params.value;
    let organizations = JSON.parse(localStorage.getItem("organizations"));
    let org = organizations.filter((ele) => {
      return ele.id == this.smsrechargepo.organizationId;
    });
    this.orgniationNam =
      org.length > 0 ? org[0].displayName : this.L("Unknown");
    let sms = this.smspackage.filter((ele) => {
      return ele.id == this.smsrechargepo.smsPackageId;
    });
    this.smspackageName = sms.length > 0 ? sms[0].name : this.L("Unknown");
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    let paytype = detaillist.filter((ele) => {
      return ele.id == this.smsrechargepo.payTypeId;
    });
    this.paytypeName = paytype.length > 0 ? paytype[0].name : this.L("Unknown");
    this.$store
      .dispatch({
        type: "smsrechargelist/rechargelist",
        data: this.smsrechargepo,
      })
      .then((val) => {
        //console.log(val);
        if (val != null && val != "") {
          this.troadeNo = val.out_trade_no;
          var div = document.getElementById("qrcode");
          div.innerHTML = "";
          this.$nextTick(() => {
            new QRCode("qrcode", {
              width: 170,
              height: 170,
              text: val.url, //内容，二维码地址
              colorDark: "#000", //前景色
              colorLight: "#fff", //背景色
            });
          });
          this.loading = true;
        }
      })
      .catch((err) => {
        console.log(err);
        this.loading = false;
      });
    this.timer = setInterval(() => {
      this.getPayState(this.troadeNo);
    }, 5000);
  }
  //检测状态
  async checkPayState() {
    await this.getPayState(this.troadeNo);
  }
  //获取支付状态
  async getPayState(troadeNo: string) {
    //console.log("第" + this.num + "次调用");
    this.loading = true;
    let result = false;
    await this.$store
      .dispatch({ type: "smsrechargelist/checkPayState", data: troadeNo })
      .then((data) => {
        //console.log("回调值:" + data);
        if (data) {
          result = true;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    if (result) {
      clearInterval(this.timer);
      this.$Modal.success({
        title: this.L("Tips"),
        content: this.L("PaySucess"),
        okText: this.L("Yes"),
        onOk: async () => {
          this.$store.commit("app/closePage", "paysmsorder");
          this.$store.commit("app/removeTag", "paysmsorder");
          this.$router.push({
            name: "smsrechargelist",
            params: { params: "" },
          });
        },
      });
    }
    if (this.num >= 20) {
      clearInterval(this.timer);
      this.$Modal.error({
        title: this.L("Tips"),
        content: this.L("PayFail"),
        okText: this.L("Yes"),
        onOk: async () => {
          this.$store.commit("app/closePage", "paysmsorder");
          this.$store.commit("app/removeTag", "paysmsorder");
          this.$router.push({
            name: "smsrechargelist",
            params: { params: "" },
          });
        },
      });
    }
    this.num++;
  }
  // 页面关闭时销毁定时器
  beforeDestroy() {
    clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
  }
  //选择支付方式
  changePayMent() {
    (this.$refs.queryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let res = this.$store
          .dispatch({
            type: "smsrechargelist/create",
            data: this.smsrechargepo,
          })
          .then((val) => {
            // if (val != null && val != "") {
            //   var div = document.getElementById("qrcode");
            //   div.innerHTML = "";
            //   this.$nextTick(() => {
            //     new QRCode("qrcode", {
            //       width: 170,
            //       height: 170,
            //       text: val, //内容，二维码地址
            //       colorDark: "#000", //前景色
            //       colorLight: "#fff", //背景色
            //     });
            //   });
            // }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }
  itemRule = {
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    smsPackageId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rechargePrice: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rechargeNum: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rechargeAmmount: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    payTypeId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  //获取充值包
  async getSMSPackage() {
    let res = await this.$store
      .dispatch("smspackage/getAllSMSPackage")
      .then((val) => {
        if (val.length > 0) {
          this.smspackage = val;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
